import { useOutsideClick } from '@chakra-ui/react'

export default useOutsideClick
